export default "__VITE_ASSET__34676a3d__"